module.exports = __webpack_public_path__ + "img/s8sLogo2.d5590517.png";